import { render } from "./Onboarding.vue?vue&type=template&id=739df558"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__